import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_FEATURE_KEY, UserState } from './user.reducer';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';
import { selectShowLoader } from '@lyceo/shared/auth/data-access';
import { selectSettingsLoading } from '@lyceo/homi/login/data-access';

export const selectUserState =
  createFeatureSelector<UserState>(USER_FEATURE_KEY);

export const selectPlanPermissionsCallState = createSelector(
  selectUserState,
  (state) => state.planPermissions,
);

export const selectPlanPermissionsLoaded = createSelector(
  selectPlanPermissionsCallState,
  (callState: CallState) => callState === LoadingState.LOADED,
);

export const selectPersonIdCallState = createSelector(
  selectUserState,
  (state) => state.personIdCallState,
);

export const selectPersonId = createSelector(
  selectUserState,
  (state) => state.personId,
);

export const selectPersonIdLoaded = createSelector(
  selectPersonIdCallState,
  (callState: CallState) => callState === LoadingState.LOADED,
);

export const selectPersonIdLoading = createSelector(
  selectPersonIdCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectPersonIdError = createSelector(
  selectPersonIdCallState,
  (callState) => getError(callState),
);

export const selectHasPersonIdError = createSelector(
  selectPersonIdError,
  (error) => !!error,
);

export const selectUserShowLoader = createSelector(
  selectShowLoader,
  selectSettingsLoading,
  selectPersonIdLoading,
  (showLoader, settingsLoading, personIdLoading) =>
    showLoader || settingsLoading || personIdLoading,
);
